/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Parts_4_DescInputs */

const en_mk_parts_4_desc = /** @type {(inputs: Mk_Parts_4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tone of voice, forbidden words, prices and processes stored once. Every agent reads them before it works, so a correction you make today still holds next month.`)
};

const id_mk_parts_4_desc = /** @type {(inputs: Mk_Parts_4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nada bicara, kata terlarang, harga, dan cara kerja disimpan sekali. Setiap agen membacanya sebelum bekerja, jadi koreksi Anda hari ini masih berlaku bulan depan.`)
};

/**
* | output |
* | --- |
* | "Tone of voice, forbidden words, prices and processes stored once. Every agent reads them before it works, so a correction you make today still holds next month." |
*
* @param {Mk_Parts_4_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_parts_4_desc = /** @type {((inputs?: Mk_Parts_4_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Parts_4_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_parts_4_desc(inputs)
	return en_mk_parts_4_desc(inputs)
});